import React from 'react';

import { CSSInterpolation } from '@emotion/css/create-instance';
import { css } from '@emotion/react';
import { CssVars } from '@robinhood/design';

interface PropsIface extends React.ComponentProps<'div'> {
  overrideRootStyles?: CSSInterpolation;
}

const Cell = ({ overrideRootStyles, ...props }: PropsIface) => {
  return (
    <div css={[root, overrideRootStyles]} {...props}>
      {props.children}
    </div>
  );
};

const root = css`
  background-color: ${CssVars.neutral.bg2};
  padding: 24px;
  border-radius: 12px;
  width: 100%;
`;

export default Cell;
